import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { appNotify } from 'store/actions';
import { OpportunityStatusChip } from 'components/layout';

const UnderwriteInfoModal = ({
  isOpen,
  classes,
  setIsOpen,
  appNotify,
  underwriteTxnOppId,
  setUnderwriteTxnOppId,
  getUnderwriteInfo,
  setGridLoading,
  selectedRow
}) => {
  const [underwriteInfo, setUnderwriteInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (underwriteTxnOppId && isOpen) {
      setIsLoading(true);
      getUnderwriteInfo(underwriteTxnOppId).then(res => {
        if (!res) { // underwrite was deleted
          appNotify('Underwrite not found', 'warning');
        } else {
          setUnderwriteInfo(res);
        } 
        setIsLoading(false);
      }).catch(error => {
        setIsLoading(false);
        appNotify(`Error fetching underwrite info: ${error.message}`, 'error');
      })
    }
  }, [underwriteTxnOppId]);

  const handleClose = () => {
    setUnderwriteTxnOppId(null);
    setUnderwriteInfo(null);
    setIsOpen(false);
  }
  return (
    <>
      {
        underwriteInfo ?
          <Dialog
            open={isOpen}
            onClose={handleClose}
            maxWidth='sm'
            fullWidth
          >
            <DialogTitle disableTypography={true} className={classes.dialogTitleRoot}>
              <Typography variant={'h6'}>
                Underwrite Info - {selectedRow?.streetAddress}
              </Typography>
            </DialogTitle>
            <IconButton className={classes.closeButton} onClick={handleClose}>
              <ClearIcon fontSize="inherit" />
            </IconButton>
            <DialogContent className={classes.dialogContentRoot}>
            {!isLoading 
              ? 
              <div>
                <div className={classes.infoGroup}>
                  <Typography variant='body2' className={classes.label}>Prospect ID</Typography>
                  <Typography variant='body2'>{selectedRow?.id}</Typography>
                </div>
                <div className={classes.infoGroup}>
                  <Typography variant='body2' className={classes.label}>Transaction Opportunity ID</Typography>
                  <Typography variant='body2'>{underwriteInfo?.id}</Typography>
                </div>
                <div className={classes.infoGroup}>
                  <Typography variant='body2' className={classes.label}>Opportunity Status</Typography>
                  {underwriteInfo?.opportunityStatus ? <OpportunityStatusChip txnOpp={underwriteInfo} /> : 'N/A' }
                </div>
                <div className={classes.infoGroup}>
                  <Typography variant='body2' className={classes.label}>CRM Status</Typography>
                  <Typography variant='body2'>{underwriteInfo?.prismStatus ? underwriteInfo.prismStatus : 'N/A' }</Typography>
                </div>
                <div className={classes.infoGroup}>
                  <Typography variant='body2' className={classes.label}>Underwrite User</Typography>
                  <Typography variant='body2'>{underwriteInfo?.selectedValuationUserName}</Typography>
                </div>
                <div className={classes.infoGroup}>
                  <Typography variant='body2' className={classes.label}>Termination Reason</Typography>
                  <Typography variant='body2'>{underwriteInfo?.terminateReason}</Typography>
                </div>
                <div className={classes.infoGroup}>
                  <Typography variant='body2' className={classes.label}>No Bid Reason</Typography>
                  <Typography variant='body2'>{underwriteInfo?.selectedValuationNoBidReason}</Typography>
                </div>
                <div className={classes.infoGroup}>
                  <Typography variant='body2' className={classes.label}>Underwrite Notes</Typography>
                  <Typography variant='body2'>{underwriteInfo?.selectedValuationUnderwriteNotes}</Typography>
                </div>
              </div>
              : <div className={classes.loadingWrapper}>
                  <CircularProgress />
                </div>
            }
            </DialogContent>
          </Dialog>
          : null
      }
    </>
  );
};

const styles = theme => ({
  loadingWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  },
  infoGroup: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  label: {
    marginRight: '1rem',
    whiteSpace: 'nowrap'
  },
  filterField: {
    marginTop: 16
  },
  dialogTitleRoot: {
    paddingBottom: 0
  },
  dialogContentRoot: {
    marginBottom: '1rem',
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    backgroundColor: '#ffffff'
  },
  overlay: {
    height: 'calc(100vh - (100vh - 100%) - 48px)',
    padding: theme.spacing(2),
    paddingTop: theme.spacing(),
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto'
  }
});

const mapState = state => {
  return {
    user: state.appState.user
  }
};

const mapDispatch = dispatch => {
  return {
    appNotify: (message, variant, options) => dispatch(appNotify(message, variant, options)),
  }
};

export default compose(
  withStyles(styles),
  connect(mapState, mapDispatch)
)(UnderwriteInfoModal);